/**
 * GENERATED BY KRPC GEN - LESS MODIFY BY HAND
 * product-service.ts  2026-05-15T13:37:49+08:00
 */
import type { R, RpcService, MethodConfig as M } from 'krpc-base'

import type { ProductQuery, MiniProduct } from './wy-dto'

const _ = 'Product/'

export class ProductService {
  constructor(readonly r: RpcService) {}
  // 加钟时，获取可选的套餐列表
  miniProducts(d: ProductQuery, m?: M): R<Array<MiniProduct>> {
    return this.r.async(_ + 'miniProducts', d, m)
  }
}
